// src/lib/api.js
import { auth } from "lib/auth";

/**
 * api(path, init?, options?)
 * options: { periodoId?: string }
 */
export async function api(path, init = {}, options = {}) {
  const headers = {
    "Content-Type": "application/json",
    ...(init.headers || {}),
  };

  // Attach Firebase ID token if logged in
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken(false);
    headers.Authorization = `Bearer ${token}`;
  }

  // Dashboard context: Periodo
  if (options.periodoId) {
    headers["X-Periodo-Id"] = options.periodoId;
  }

  const res = await fetch(`/api${path}`, {
    ...init,
    headers,
  });

  const contentType = res.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");

  if (!res.ok) {
    const payload = isJson ? await res.json().catch(() => null) : await res.text().catch(() => "");
    // Try to surface backend error nicely
    const msg =
      typeof payload === "string"
        ? payload
        : payload?.error
        ? payload.error
        : `Request failed: ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    err.payload = payload;
    throw err;
  }

  const body = isJson ? await res.json().catch(() => ({})) : {};
  return body.data ?? body;
}
